import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { appVersion } from 'src/environments/version';
import { environment } from 'src/environments/environment';

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let targetDomains: string[] = environment.domainsForVersioning;
    if (targetDomains.some((targetDomain) => req.url.includes(targetDomain))) {
      const cloned = req.clone({
        setHeaders: {
          'X-App-Version': appVersion,
        },
      });
      return next.handle(cloned);
    }
    return next.handle(req);
  }
}
